(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/winplan-table.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/winplan-table.js');

'use strict';

svs.numbergames.game.views.WinPlanTable = Marionette.View.extend({
  viewOptions: ['multipliedRowPrice'],
  modelEvents: {
    'change:level change:hasKungKeno change:board': 'render'
  },
  className() {
    return 'winplan-table';
  },
  template: data => svs.numbergames.game.templates.winplan_table(data),
  templateContext() {
    return {
      levelWinPlanData: this.getLevelWinPlanData()
    };
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
  },

  onChangeRowPriceMulti(multipliedRowPrice) {
    this.multipliedRowPrice = multipliedRowPrice;
    this.render();
  },
  getLevelWinPlanData() {
    const {
      getLevelWinPlanData,
      types
    } = svs.numbergames.rules.utils.keno_winplan;
    let systemNumbers;
    let type;
    if (this.model.get('isSystem')) {
      type = types.KENO_SYSTEM;
      systemNumbers = this.model.get('numbers').length;
    }
    return getLevelWinPlanData({
      type,
      systemNumbers,
      level: this.model.get('level'),
      rowPrice: this.multipliedRowPrice
    });
  }
});

 })(window);